import type { Branding } from '../../interfaces/Branding.interface';

export interface State {
    branding: Branding | null;
    isPending: boolean;
    isLoaded: boolean;
}

export const initialState: State = {
    branding: null,
    isPending: false,
    isLoaded: false
};
